<template>
  <div>
    <CRow>
      <CCol lg="26">
         <CTableWrapper :items="getUsersData()"> 
          <template #header>
            <CIcon name="cil-grid"/>Utilisateurs
            <div class="card-header-actions">
              <a 
                href="https://coreui.io/vue/docs/components/nav" 
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import CTableWrapper from './SNuser.vue'
import axios from 'axios'

export default {
  name: 'SNUsers',
  data() {
    return {
      loading: true,
      info: []
    }
  },  
  components: { 
          CTableWrapper
  },
  mounted() {
       axios.get( APIURL+'/api1/users', {   
         mode: 'no-cors',
              headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          withCredentials: false
        } )
        .then( res => this.info = res.data)
        .catch( err => console.log(err))
        .finally(() => this.loading = false) 
  },
  methods: {
    getUsersData() {
      return this.info;
    }
  }
}

</script>
